import $ from 'jquery';
import { Changer } from '../../services/changer/Changer';
import { ModifierSwitchMethodTypeEnum } from '../../enums/ModifierSwitchMethodTypeEnum';

const realModifierSwitcherV1Semantics = {
    'contextWrapClass': 'real-modifier-switcher-v1__context',
    'changesAttribute': 'data-changes',
    'select2ElementSelector': 'select.select-v2__element',
    'initiatorElementSelector': 'select.select-v2__element option',
    'observableElementSelector': '.real-modifier-switcher-v1__context .select-v2[data-context-selector=".real-modifier-switcher-v1__context"] select.select-v2__element',
    'switcherWrapClass': 'real-modifier-switcher-v1',
    'switchMethodTypeAttribute': 'data-modifier-switch-method-type-id',
    'multiSwitchContextSelectorAttribute': 'data-multi-switch-context-selector',
    'multiSwitchCardSelectorAttribute': 'data-multi-switch-card-selector',
    'modifiedTemplateIdAttribute': 'data-modifier-template-id',
    'productIdAttribute': 'data-product-id',
    'multiSwitchPreloaderSelector': '.page-preloader',
};

$(function() {

    var realModifierSwitcherV1 = new RealModifierSwitcherV1();
    realModifierSwitcherV1.subscribe();

});

class RealModifierSwitcherV1
{
    subscribe() {

        let self = this;

        // change real modifier on every card on page
        $(document).on(
            'select2:select', 
            realModifierSwitcherV1Semantics.observableElementSelector, 
            function(e) {

                if (typeof e.data === 'object' && e.data.isSkippedEvent === true) {
                    return;
                };

                let switcherWrapElement = $(e.target).closest(
                    `.${realModifierSwitcherV1Semantics.switcherWrapClass}`
                );
                let cardContextElement = $(e.target).closest(
                    `.${realModifierSwitcherV1Semantics.contextWrapClass}`
                );
                let selectElement = $(e.target);
                let optionElement = selectElement.find(`option[value="${selectElement.val()}"]`);
                if (!switcherWrapElement.length) {
                    console.error(
                        `При смене модификатора у элемента [selectElement] ` +
                        `не найден wrap-элемент по селектору [.${realModifierSwitcherV1Semantics.switcherWrapClass}]! ` +
                        `Переключение модификатора не будет обработано!`,
                        {
                            selectElement: e.target,
                        }
                    );
                    return;
                }
                if (!cardContextElement.length) {
                    console.error(
                        `При смене модификатора у элемента [selectElement] ` +
                        `не найдена базовая карточка по селектору [.${realModifierSwitcherV1Semantics.contextWrapClass}]! ` +
                        `Переключение модификатора не будет обработано!`,
                        {
                            selectElement: e.target,
                        }
                    );
                    return;
                }
                if (!optionElement.length) {
                    console.error(
                        `При смене модификатора у элемента [selectElement] ` +
                        `не найден элемент option по селектору [option[value="${selectElement.val()}"]]! ` +
                        `Переключение модификатора не будет обработано!`,
                        {
                            selectElement: e.target,
                        }
                    );
                    return;
                }
                let modifierTemplateId = parseInt(
                    optionElement.attr(
                        realModifierSwitcherV1Semantics.modifiedTemplateIdAttribute
                    )
                );
                if (modifierTemplateId <= 0) {
                    console.error(
                        `При смене модификатора у элемента [selectElement] ` +
                        `не найден modifierTemplateId у выбранной опции [optionElement]! ` +
                        `Переключение модификатора не будет обработано!`,
                        {
                            selectElement: e.target,
                            optionElement: optionElement
                        }
                    );
                    return;
                }

                let switchMethodTypeId = parseInt(switcherWrapElement.attr(
                    `${realModifierSwitcherV1Semantics.switchMethodTypeAttribute}`
                ));
                let multiSwitchContextSelector = switcherWrapElement.attr(
                    `${realModifierSwitcherV1Semantics.multiSwitchContextSelectorAttribute}`
                ) ?? null;
                let multiSwitchCardSelector = switcherWrapElement.attr(
                    `${realModifierSwitcherV1Semantics.multiSwitchCardSelectorAttribute}`
                ) ?? null;
                let multiSwitchContext = null;
                if (multiSwitchContextSelector != null) {
                    multiSwitchContext = switcherWrapElement.closest(
                        multiSwitchContextSelector
                    );
                }

                // Preload-элемент для показа прелоадера
                // на момент запроса к серверу
                let multiSwitchPreloaderElement = multiSwitchContext.find(
                    realModifierSwitcherV1Semantics.multiSwitchPreloaderSelector
                );

                let baseCardIds = [];
                if (
                    multiSwitchContext !== null
                        &&
                    switchMethodTypeId == ModifierSwitchMethodTypeEnum.multi
                ) {                    
                    baseCardIds = self.retrieveBaseCardIds(
                        multiSwitchContext,
                        optionElement,
                        multiSwitchCardSelector
                    );
                } else {
                    if (parseInt(cardContextElement.attr(realModifierSwitcherV1Semantics.productIdAttribute)) > 0) {
                        baseCardIds = [
                            parseInt(cardContextElement.attr(realModifierSwitcherV1Semantics.productIdAttribute))
                        ];
                    }
                }
                if (!baseCardIds.length) {
                    console.error(
                        `При смене модификатора у элемента [selectElement] ` +
                        `не найдены идентификаторы базовых карточек! ` +
                        `Переключение модификатора не будет обработано!`,
                        {
                            selectElement: e.target,
                        }
                    );
                    return;
                }
                switch (switchMethodTypeId) {
                    case ModifierSwitchMethodTypeEnum.multi:
                    case ModifierSwitchMethodTypeEnum.single:
                        let params = {
                            modifierTemplateId: modifierTemplateId,
                            baseCardIds: baseCardIds,
                        };
                        if (multiSwitchPreloaderElement.length) {
                            multiSwitchPreloaderElement.show();
                        }
                        $.ajax({
                            url: '/real-modifier-switcher/generate-js-changes',
                            method: 'GET',
                            // processData: false,
                            // contentType: false,
                            cache: false,
                            data: params,
                            success: function (data) {
                                if (typeof data !== 'object') {
                                    console.error(
                                        `При смене модификатора у элемента [selectElement] ` +
                                        `от сервера пришли невалидные данные! [responseData]` +
                                        `Переключение модификатора не будет обработано!`,
                                        {
                                            selectElement: e.target,
                                            responseData: data
                                        }
                                    );
                                }
                                for (var baseCardId in data) {
                                    // переключаются данные модификатора
                                    let baseCardElement = multiSwitchContext.find(
                                        multiSwitchCardSelector + 
                                        `[data-product-id="${baseCardId}"]`
                                    );
                                    self.switch(
                                        baseCardElement,
                                        data[baseCardId]
                                    );
                                    // устанавливаем сам модификатор в select-поле
                                    let select2Element = baseCardElement.find(
                                        realModifierSwitcherV1Semantics
                                            .select2ElementSelector
                                    );
                                    let select2OptionElement = baseCardElement.find(
                                        `${
                                            realModifierSwitcherV1Semantics
                                                .initiatorElementSelector
                                        }[${
                                            realModifierSwitcherV1Semantics
                                                .modifiedTemplateIdAttribute
                                        }="${modifierTemplateId}"]`
                                    );
                                    select2Element.val(
                                        select2OptionElement.attr('value')
                                    ).trigger('change');
                                }
                                if (multiSwitchPreloaderElement.length) {
                                    multiSwitchPreloaderElement.hide();
                                }
                            },
                            error: function(data) {
                                console.error(
                                    `При смене модификатора у элемента [selectElement] ` +
                                    `при попытке получить данные с сервера получена ошибка: [responseData] ` +
                                    `Переключение модификатора не будет обработано!`,
                                    {
                                        selectElement: e.target,
                                        responseData: data
                                    }
                                );
                                if (multiSwitchPreloaderElement.length) {
                                    multiSwitchPreloaderElement.hide();
                                }
                            }
                        });
                    break;
                    default:
                        console.error(
                            `При смене модификатора у элемента [selectElement] ` +
                            `установлен неизвестный тип метода переключения switchMethodTypeId=[${switchMethodTypeId}]! ` +
                            `Переключение модификатора не будет обработано!`,
                            {
                                selectElement: e.target,
                                responseData: data
                            }
                        );
                        return;
                    break;
                }

                // let switcher = new RealModifierSwitcherV1Context(cardContextElement)
                // switcher.switch(optionElement);

                window.widgets.addToCartV1.checkSelected();
            }
        );

    }

    /**
     * У каждой карточки есть элемент `.${switcherWrapClass}`
     * В нем находится список модификаторов в select2  в опциях
     * observableElementSelector, у него можно получить .attr(${modifiedTemplateIdAttribute})
     * и проверить каждую карточку - есть ли у них такой же modifierTemplateId,
     * на сервер уходят только идентификаторы нужных базовых карточек
     * @param jQuery multiSwitchContext
     * @param jQuery currentOptionElement
     * @param string multiSwitchCardSelector
     * @return []
     */
    retrieveBaseCardIds(
        multiSwitchContext,
        currentOptionElement,
        multiSwitchCardSelector
    ) {
        let baseCardIds = [];

        let multiSwitchCards = multiSwitchContext.find(
            multiSwitchCardSelector
        );
        $.each(
            multiSwitchCards,
            (k, v) => {
                let option = $(v).find(
                    `${realModifierSwitcherV1Semantics.initiatorElementSelector}` +
                    `[${realModifierSwitcherV1Semantics.modifiedTemplateIdAttribute}="` + 
                    `${currentOptionElement.attr(
                        realModifierSwitcherV1Semantics.modifiedTemplateIdAttribute
                    )}"]`
                );
                if (option.length) {
                    if (parseInt(
                        $(v).attr(
                            realModifierSwitcherV1Semantics.productIdAttribute
                        )
                    ) > 0) {
                        baseCardIds.push(
                            $(v).attr(
                                realModifierSwitcherV1Semantics.productIdAttribute
                            )
                        );
                    }
                }
            }
        );
        return baseCardIds;
    }

    /**
     * @param {jQuery|null} context
     * @param {[]} rawChanges 
     */
    switch(context, rawChanges) {
        
        let self = this;
        if (!Array.isArray(rawChanges) || !rawChanges.length) {
            return;
        }

        let changer = new Changer();
        // changer.isLog = true;
        changer.rawChanges = rawChanges;
        changer.contextElement = context;
        changer.buildChanges();
        changer.runChanges();

    }
}